import type { VAxios } from '../../define/axios/Axios';

import {
  CollectParams,
  CollectionRes,
  CollectionDirsParams,
} from '../../entities/cc/collections.entities';

/**
 * 采集接口配置
 */
export const createApi = (defHttp: VAxios) => ({
  //#region 采集接口
  // 采集
  collect: (params: CollectParams) => {
    return defHttp.post<string>({ url: `/aiad/collections`, params });
  },
  // 取消采集
  cancelCollect: (id: string) => {
    return defHttp.delete<string>({ url: `/aiad/collections/${id}` });
  },
  // 查询采集内容
  queryCollections: (params) => {
    return defHttp.get<{
      total: number;
      items: CollectionRes[];
    }>({ url: `/aiad/collections`, params });
  },
  // 灵感集列表
  queryDirs: () => {
    return defHttp.get<Array<{ id: string; name: string }>>({ url: `/aiad/collections/dirs` });
  },
  // 增加灵感集
  addDir: (params: CollectionDirsParams) => {
    return defHttp.post<string>({
      url: '/aiad/collections/dirs',
      params,
    });
  },
  // 查看灵感详情
  fetchDir: (id: string) => {
    return defHttp.get<{ id: string; name: string }>({
      url: `/aiad/collections/dirs/${id}`,
    });
  },
  //#endregion
});
